










import { Component, Vue, Prop } from "vue-property-decorator";
import {
  COLOR_BUTTON_RED,
  COLOR_BUTTON_YELLOW,
  COLOR_BUTTON_GREEN,
  COLOR_BUTTON_WHITE,
} from "@/utils/colors";
import { themedFill } from "@/utils/Theme";
import {
  TaskSchedulingInfoItem,
  TaskSchedulingInfoItemColor,
} from "./TaskSchedulingInfo.vue";

@Component
export default class TaskSchedulingInfoItemComponent extends Vue {
  @Prop()
  infoItem!: TaskSchedulingInfoItem | null;

  getSpanStyle(contentItem: TaskSchedulingInfoItem) {
    let backgroundColor = COLOR_BUTTON_WHITE;

    switch (contentItem.color) {
      case TaskSchedulingInfoItemColor.WHITE:
        backgroundColor = COLOR_BUTTON_WHITE;
        break;
      case TaskSchedulingInfoItemColor.GREEN:
        backgroundColor = COLOR_BUTTON_GREEN;
        break;
      case TaskSchedulingInfoItemColor.YELLOW:
        backgroundColor = COLOR_BUTTON_YELLOW;
        break;
      case TaskSchedulingInfoItemColor.RED:
        backgroundColor = COLOR_BUTTON_RED;
        break;
    }

    // The red marks a task's state, not an action. The label derives its colour from the fill
    // (`.opposite-color-text`), so it follows the dark palette shade by itself.
    return {
      background: themedFill(backgroundColor, "status"),
    };
  }
}
